import { render, staticRenderFns } from "./PixUpdate.vue?vue&type=template&id=b9fe764e&scoped=true&"
import script from "./PixUpdate.vue?vue&type=script&lang=js&"
export * from "./PixUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PixUpdate.vue?vue&type=style&index=0&id=b9fe764e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fe764e",
  null
  
)

export default component.exports